import axios from '../axios';

export default {
  getManufacturers (options) {
    const params = {};
    if (options.filters && Object.keys(options.filters).length) {
      for (const filterName in options.filters) {
        params[`filter[${filterName}]`] = options.filters[filterName];
      }
    }

    if (options.include) {
      params.include = options.include;
    }

    if (options.limit) {
      params.limit = options.limit;
    }

    if (options.sort) {
      params.sort = options.sort;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get('/device_manufacturer?' + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
